import * as svgs from './*.svg';

export type icons =
    | 'chatgpt'
    | 'sparkle'
    | 'task-checkmark'
    | 'task-circle'
    | 'circle'
    | 'task-paused'
    | 'task-working'
    | 'task-locked';

interface IconProps {
    icon: icons;
    className?: string;
}

export const GetIcon = (section: icons): string => {
    if (!svgs[section]) {
        return null;
    }
    return svgs[section];
};

export const Icon = (p: IconProps) => {
    return (
        <div className={p.className}>
            <img src={svgs[p.icon]} />
        </div>
    );
};
